/**
 * Read-only banner for the orboto Mail pages (OCP-545).
 *
 * Shown to members whose role may look at the mail setup but not change
 * it. One component so the wording is identical on every Mail page and a
 * new page starts with the same explanation instead of inventing one.
 */
import { useTranslation } from 'react-i18next';

import { useMailWriteAccess } from '../lib/use-mail-write-access';

export function MailReadOnlyNotice({ className }: { className?: string }) {
  const { canWrite, readOnlyReason, role } = useMailWriteAccess();
  const { t } = useTranslation('mail-layout');
  if (canWrite || role === null) return null;
  return (
    <div
      role="status"
      data-testid="mail-read-only-notice"
      className={[
        'rounded-lg border border-amber-200 dark:border-amber-900/50 bg-amber-50 dark:bg-amber-900/30 px-3 py-2 text-sm text-amber-900 dark:text-amber-200',
        className ?? 'mb-4',
      ].join(' ')}
    >
      {readOnlyReason} {t('readOnly.askAdmin')}
    </div>
  );
}
